import axios from 'axios';
import qs from 'qs';

export const stringifyQuery = (params) => (
  qs.stringify(params, { arrayFormat: 'repeat' })
);

// export default function createAxios({ host = 'https://testapi.powerai.com.tw/' }) {
// export default function createAxios({ host = 'http://104.199.181.82:4000/' }) {
// export default function createAxios({ host = 'http://35.220.212.153:4000/' }) {
export default function createAxios({ host = 'https://api.powerai.com.tw/' }) {
  const instance = axios.create({
    baseURL: host,
  });

  instance.interceptors.response.use((res) => res, (error) => {
    if (!error.response) {
      if (error?.message === 'Network Error') {
        /* eslint-disable no-param-reassign */
        error.errorMsg = '系統連線異常，請重新整理視窗或檢查您的網路連線';
        /* eslint-enable no-param-reassign */
      }
      return Promise.reject(error);
    }

    if (error?.response?.status === 401) {
      /* eslint-disable no-param-reassign */
      error.errorMsg = '登入失敗，請再重新登入，謝謝！';
      /* eslint-enable no-param-reassign */
    }

    if (![403, 401].includes(error.response.status)
    || !error.response.data
    || !error.response.data.errors
    || error.response.data.errors[0].field !== 'INVALID_JSON_WEB_TOKEN') {
      return Promise.reject(error);
    }

    return instance(error.response.config);
  });
  // axios.defaults.headers['Content-Type'] = 'application/json';
  delete instance.defaults.headers.common['Content-Type'];
  delete instance.defaults.headers.common['Access-Control-Request-Headers'];
  return instance;
}
